const actions = {
  GET_PRODUCTS_BEGIN: 'GET_PRODUCTS_BEGIN',
  GET_PRODUCTS: 'GET_PRODUCTS',
  GET_PRODUCTS_ERR: 'GET_PRODUCTS_ERR',
  CREATE_PRODUCT: 'CREATE_PRODUCT',
  CREATE_PRODUCT_BEGIN: 'CREATE_PRODUCT_BEGIN',
  CREATE_PRODUCT_ERR: 'CREATE_PRODUCT_ERR',
  GET_CATEGORIES: 'GET_CATEGORIES',
  GET_CATEGORIES_BEGIN: 'GET_CATEGORIES_BEGIN',
  GET_CATEGORIES_ERR: 'GET_CATEGORIES_ERR',
  GET_OPTIONS: 'GET_OPTIONS',
  GET_OPTIONS_BEGIN: 'GET_OPTIONS_BEGIN',
  GET_OPTIONS_ERR: 'GET_OPTIONS_ERR',
  CREATE_OPTION: 'CREATE_OPTION',
  CREATE_OPTION_BEGIN: 'CREATE_OPTION_BEGIN',
  CREATE_OPTION_ERR: 'CREATE_OPTION_ERR',
  UPDATE_OPTION: 'UPDATE_OPTION',
  UPDATE_OPTION_BEGIN: 'UPDATE_OPTION_BEGIN',
  UPDATE_OPTION_ERR: 'UPDATE_OPTION_ERR',
  DELETE_OPTION: 'DELETE_OPTION',
  DELETE_OPTION_BEGIN: 'DELETE_OPTION_BEGIN',
  DELETE_OPTION_ERR: 'DELETE_OPTION_ERR',
  GET_SELECTIONS: 'GET_SELECTIONS',
  GET_SELECTIONS_BEGIN: 'GET_SELECTIONS_BEGIN',
  GET_SELECTIONS_ERR: 'GET_SELECTIONS_ERR',
  CREATE_SELECTION: 'CREATE_SELECTION',
  CREATE_SELECTION_BEGIN: 'CREATE_SELECTION_BEGIN',
  CREATE_SELECTION_ERR: 'CREATE_SELECTION_ERR',
  UPDATE_SELECTION: 'UPDATE_SELECTION',
  UPDATE_SELECTION_BEGIN: 'UPDATE_SELECTION_BEGIN',
  UPDATE_SELECTION_ERR: 'UPDATE_SELECTION_ERR',
  DELETE_SELECTION: 'DELETE_SELECTION',
  DELETE_SELECTION_BEGIN: 'DELETE_SELECTION_BEGIN',
  DELETE_SELECTION_ERR: 'DELETE_SELECTION_ERR',

  getProducts: data => {
    return {
      type: actions.GET_PRODUCTS,
      data,
    };
  },

  getProductsBegin: () => {
    return {
      type: actions.GET_PRODUCTS_BEGIN,
    };
  },

  getProductsError: err => {
    return {
      type: actions.GET_PRODUCTS_ERR,
      err,
    };
  },

  createProducts: () => {
    return {
      type: actions.CREATE_PRODUCT,
    };
  },

  createProductsBegin: () => {
    return {
      type: actions.CREATE_PRODUCT_BEGIN,
    };
  },

  createProductsError: err => {
    return {
      type: actions.CREATE_PRODUCT_ERR,
      err,
    };
  },

  getCategoriesBegin: () => {
    return {
      type: actions.GET_CATEGORIES_BEGIN,
    };
  },

  getCategories: data => {
    return {
      type: actions.GET_CATEGORIES,
      data,
    };
  },

  getCategoriesError: err => {
    return {
      type: actions.GET_CATEGORIES_ERR,
      err,
    };
  },

  getOptionsBegin: () => {
    return {
      type: actions.GET_OPTIONS_BEGIN,
    };
  },

  getOptions: data => {
    return {
      type: actions.GET_OPTIONS,
      data,
    };
  },

  getOptionsError: err => {
    return {
      type: actions.GET_OPTIONS_ERR,
      err,
    };
  },

  // Option CRUD actions
  createOptionBegin: () => {
    return {
      type: actions.CREATE_OPTION_BEGIN,
    };
  },

  createOption: () => {
    return {
      type: actions.CREATE_OPTION,
    };
  },

  createOptionError: err => {
    return {
      type: actions.CREATE_OPTION_ERR,
      err,
    };
  },

  updateOptionBegin: () => {
    return {
      type: actions.UPDATE_OPTION_BEGIN,
    };
  },

  updateOption: data => {
    return {
      type: actions.UPDATE_OPTION,
      data,
    };
  },

  updateOptionError: err => {
    return {
      type: actions.UPDATE_OPTION_ERR,
      err,
    };
  },

  deleteOptionBegin: () => {
    return {
      type: actions.DELETE_OPTION_BEGIN,
    };
  },

  deleteOption: id => {
    return {
      type: actions.DELETE_OPTION,
      id,
    };
  },

  deleteOptionError: err => {
    return {
      type: actions.DELETE_OPTION_ERR,
      err,
    };
  },

  // Selection CRUD actions
  getSelectionsBegin: () => {
    return {
      type: actions.GET_SELECTIONS_BEGIN,
    };
  },

  getSelections: data => {
    return {
      type: actions.GET_SELECTIONS,
      data,
    };
  },

  getSelectionsError: err => {
    return {
      type: actions.GET_SELECTIONS_ERR,
      err,
    };
  },

  createSelectionBegin: () => {
    return {
      type: actions.CREATE_SELECTION_BEGIN,
    };
  },

  createSelection: data => {
    return {
      type: actions.CREATE_SELECTION,
      data,
    };
  },

  createSelectionError: err => {
    return {
      type: actions.CREATE_SELECTION_ERR,
      err,
    };
  },

  updateSelectionBegin: () => {
    return {
      type: actions.UPDATE_SELECTION_BEGIN,
    };
  },

  updateSelection: data => {
    return {
      type: actions.UPDATE_SELECTION,
      data,
    };
  },

  updateSelectionError: err => {
    return {
      type: actions.UPDATE_SELECTION_ERR,
      err,
    };
  },

  deleteSelectionBegin: () => {
    return {
      type: actions.DELETE_SELECTION_BEGIN,
    };
  },

  deleteSelection: id => {
    return {
      type: actions.DELETE_SELECTION,
      id,
    };
  },

  deleteSelectionError: err => {
    return {
      type: actions.DELETE_SELECTION_ERR,
      err,
    };
  },
};

export default actions;
